import CopyFixList from './CopyFixList';
import { extractJsonLd } from '../../../../lib/optimizedContent';

export default function SchemaFix({ domain, onFixApplied }) {
  return (
    <CopyFixList
      domain={domain}
      pillarCode="schemaMarkup"
      threshold={12}
      extract={extractJsonLd}
      copyLabel={(e) =>
        `${e.count} JSON-LD ${e.count === 1 ? 'script' : 'scripts'}${
          e.types.length ? ` (${e.types.join(', ')})` : ''
        }`
      }
      clipboardText={(e) => e.scriptsText}
      emptyHint="Run a fresh audit if you’ve recently deployed schema."
      onFixApplied={onFixApplied}
      instructions={[
        <>
          Paste the copied <code className="px-1 bg-white border border-emerald-200 rounded text-[10px]">&lt;script type=&quot;application/ld+json&quot;&gt;</code> blocks just before <code className="px-1 bg-white border border-emerald-200 rounded text-[10px]">&lt;/head&gt;</code> in your page template.
        </>,
        'Deploy the change to your live site.',
        <>
          Re-run the audit — <strong>JSON-LD schema detected</strong> should now Pass.
        </>,
      ]}
    />
  );
}
